export default __webpack_public_path__ + "static/media/resume.32d351f8.pdf";